// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 601) return "static/chunks/9761e08b-6016c4140f3e02dc.js";
	if (chunkId === 480) return "static/chunks/480-a0a81b9433728e4f.js";
	if (chunkId === 874) return "static/chunks/874-4f93dd85f99f087c.js";
	if (chunkId === 452) return "static/chunks/452-5c09dbcf8cc426f9.js";
	if (chunkId === 545) return "static/chunks/545-161567b0fe4ec2fc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"130":"7717d37b5a1b38ff","132":"3c104c04a5be0dc4","277":"5db17ca1e0bab4df","510":"8675ad4414fe5090","771":"50b7111f625c4490"}[chunkId] + ".js";
};